/** Fechas como claves de día locales `yyyy-MM-dd` (mismo formato que la columna `date` del libro). */

const pad = (n: number) => String(n).padStart(2, '0');

export function dateKey(d: Date = new Date()): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Día `n` días después (o antes) de `key`. Usa el mediodía local para no tropezar con los cambios de hora. */
export function addDays(key: string, n: number): string {
  const [y, m, d] = key.split('-').map(Number) as [number, number, number];
  return dateKey(new Date(y, m - 1, d + n, 12));
}

export const isDateKey = (s: string) => /^\d{4}-\d{2}-\d{2}$/.test(s);
